import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { useLoginStore } from "@/Modules/Auth/Login/Store";
import { useRedirect } from "@/hooks";
import useApi, { ApiRequestError } from "@/hooks/useApi";
import { useCompanyStore, useLoggedUserStore } from "@/Store";

const RequiredUnauth = () => {
  const sessionId = useLoginStore((state) => state.sessionId);
  const { clearSession } = useLoginStore();
  const redirect = useRedirect();
  const { getRequest } = useApi();
  const clearCompanyContext = useCompanyStore(
    (state) => state.clearCompanyContext
  );
  const setLoggedUser = useLoggedUserStore((state) => state.setLoggedUser);

  useEffect(() => {
    if (sessionId) {
      getRequest("/api/user")
        .then(() => {
          redirect("/visao-geral");
        })
        .catch(async (requestError: unknown) => {
          let effectiveError = requestError;
          if (
            requestError instanceof ApiRequestError &&
            requestError.status === 403
          ) {
            clearCompanyContext();
            try {
              await getRequest("/api/user");
              redirect("/visao-geral");
              return;
            } catch (retryError: unknown) {
              effectiveError = retryError;
            }
          }
          if (
            effectiveError instanceof ApiRequestError &&
            effectiveError.status === 401
          ) {
            setLoggedUser(null);
            clearSession();
            redirect("/login");
          }
        });
    }
  }, [sessionId]);

  return <Outlet />;
};

export default RequiredUnauth;
